import React from 'react';
import { Box } from 'edenred-ui';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { BenefitTypeCard } from '@epi-shared/components';
import { ContractedBenefitsSettings } from '@epi-models/pages/BenefitGroups';

interface SelectBenefitsBarProps {
  contractedBenefits: ContractedBenefitsSettings[];
  disabled?: boolean;
}
export const SelectBenefitsBar = ({
  contractedBenefits,
  disabled
}: SelectBenefitsBarProps) => {
  const {
    sizeMedium,
    gray5,
    gray50,
    gray85,
    fontSemiBold,
    primaryFrontColor,
    lightBlue5,
    primaryBackColorLight20
  } = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      p={3}
      bgcolor={disabled ? gray5 : lightBlue5}
      border={`1px solid ${primaryBackColorLight20}`}
      position="sticky"
      top="0"
      zIndex={99}
      display={disabled ? gray50 : gray85}
    >
      <Box
        mb={3}
        fontSize={sizeMedium}
        fontWeight={fontSemiBold}
        color={primaryFrontColor}
      >
        {t('containers.benefit_groups.select_benefits')}
      </Box>
      <Box display="flex" flexDirection="row" flexWrap="wrap" gap={3}>
        {contractedBenefits.map(({ benefitType, maxAmount }) => (
          <BenefitTypeCard
            benefitType={benefitType}
            key={`benefit-card-${benefitType}`}
            maxAmount={maxAmount}
            disabled={disabled}
          />
        ))}
      </Box>
    </Box>
  );
};
